import { render, staticRenderFns } from "./depManage.vue?vue&type=template&id=47444bd1&scoped=true&"
import script from "./depManage.vue?vue&type=script&lang=js&"
export * from "./depManage.vue?vue&type=script&lang=js&"
import style0 from "./depManage.vue?vue&type=style&index=0&id=47444bd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47444bd1",
  null
  
)

export default component.exports